export default function BAHero() {
  return (
    <section className="relative overflow-hidden" style={{ background: "linear-gradient(135deg, #0f2460 0%, #1a3a8a 50%, #0e4a7a 100%)", minHeight: 560 }}>
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20business%20analytics%20dashboard%20with%20glowing%20charts%20graphs%20and%20data%20visualization%2C%20dark%20green%20teal%20background%2C%20floating%20numbers%20and%20statistics%2C%20corporate%20finance%20data%20analysis%20technology&width=1440&height=520&seq=ba-hero-1&orientation=landscape"
          alt="商业选址分析背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#0f2460]/90 via-[#0f2460]/60 to-transparent"></div>
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: "linear-gradient(rgba(100,200,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(100,200,255,0.3) 1px, transparent 1px)", backgroundSize: "48px 48px" }}>
      </div>

      <div className="relative max-w-7xl mx-auto px-8 pt-20 pb-24 flex items-center gap-14">
        {/* Left */}
        <div className="flex-1 min-w-0">
          <div className="inline-flex items-center gap-2 bg-cyan-400/10 border border-cyan-400/30 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-map-pin-2-line text-cyan-300 text-sm"></i>
            <span className="text-cyan-300 text-xs font-medium tracking-wide">GIS空间分析 · 精准选址 · 竞品洞察</span>
          </div>
          <h1 className="text-4xl font-bold text-white leading-tight mb-3">
            商业选址分析
            <span className="block text-xl font-normal text-cyan-300 mt-2">Business Location Intelligence</span>
          </h1>
          <p className="text-blue-100/80 text-sm leading-relaxed mb-6 max-w-lg">
            融合人口热力、客群画像、业态构成、商业活力、交通指数与竞品分析，为商超、餐饮、零售等企业提供科学的选址决策支持，降低选址风险，提升经营成效。
          </p>

          {/* 6 key features */}
          <div className="flex flex-wrap gap-2 mb-8">
            {["人口热力", "客群画像", "业态构成", "商业活力", "交通指数", "竞品分析"].map((f) => (
              <span key={f} className="flex items-center gap-1.5 bg-white/10 border border-white/20 text-white/90 text-xs px-3 py-1.5 rounded-full">
                <i className="ri-checkbox-circle-line text-cyan-300 text-xs"></i>
                {f}
              </span>
            ))}
          </div>

          {/* Target customers */}
          <div className="flex items-center gap-2 mb-8">
            <span className="text-white/50 text-xs">面向客户：</span>
            {["商超", "餐饮品牌", "零售连锁", "便利店"].map((c) => (
              <span key={c} className="text-xs bg-cyan-400/15 border border-cyan-400/25 text-cyan-200 px-2.5 py-1 rounded-md">{c}</span>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <button className="bg-cyan-400 hover:bg-cyan-300 text-[#0f2460] font-semibold px-7 py-2.5 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap">
              申请免费体验
            </button>
            <button className="border border-white/30 hover:border-white/60 text-white px-7 py-2.5 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-play-circle-line"></i>查看演示
            </button>
          </div>
          <div className="flex items-center gap-8 mt-8">
            {[["5,000+", "选址项目"], ["93%", "选址成功率"], ["2周", "评估周期"]].map(([val, label]) => (
              <div key={label}>
                <div className="text-2xl font-bold text-cyan-300">{val}</div>
                <div className="text-blue-200/60 text-xs mt-0.5">{label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right: Map product screenshot */}
        <div className="flex-shrink-0 w-[460px]">
          <div className="bg-[#0a1a3a]/80 backdrop-blur-sm border border-white/15 rounded-2xl overflow-hidden">
            {/* App bar */}
            <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 bg-white/5">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-rose-400"></div>
                <div className="w-2 h-2 rounded-full bg-amber-400"></div>
                <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
              </div>
              <span className="text-white/60 text-xs">商业选址分析平台 · 区域评分报告</span>
              <span className="text-cyan-300 text-xs bg-cyan-400/10 px-2 py-0.5 rounded-full">评分中</span>
            </div>
            {/* Map/chart area */}
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=city%20level%20GIS%20map%20Chinese%20urban%20district%20bird%20eye%20view%20with%20scattered%20orange%20red%20brown%20square%20heatmap%20grid%20blocks%20of%20varying%20intensity%20overlaid%20on%20city%20road%20network%2C%20multiple%20semi-transparent%20light%20blue%20circular%20service%20area%20coverage%20zones%20with%20soft%20blurred%20edges%2C%20green%20and%20teal%20location%20pin%20markers%20scattered%20across%20the%20city%20districts%2C%20yellow%20orange%20highway%20lines%20on%20light%20gray%20beige%20map%20background%2C%20wide%20urban%20overview%20scale%20approximately%208%20to%2012%20kilometers%20showing%20multiple%20district%20names%20with%20dense%20commercial%20heat%20blocks%20concentrated%20in%20downtown%20center%2C%20realistic%20GIS%20business%20site%20selection%20analysis%20platform%20screenshot&width=460&height=208&seq=ba-city-heatmap-squares-v7&orientation=landscape"
                alt="商业选址分析图"
                className="w-full h-52 object-cover object-top"
              />
              {/* Score overlay */}
              <div className="absolute top-3 left-3 bg-[#0a1a3a]/90 border border-white/15 rounded-lg px-3 py-2">
                <div className="text-xs text-white/60 mb-0.5">综合选址评分</div>
                <div className="text-lg font-bold text-cyan-300">88.6 <span className="text-xs font-normal text-white/50">/ 100</span></div>
              </div>
              <div className="absolute top-3 right-3 bg-[#0a1a3a]/90 border border-amber-400/30 rounded-lg px-3 py-2">
                <div className="text-xs text-amber-300 font-semibold">推荐等级</div>
                <div className="text-base font-bold text-amber-300">A+</div>
              </div>
              {/* Dimension tags */}
              <div className="absolute bottom-3 left-3 right-3 flex gap-1.5 flex-wrap">
                {[["交通", "94"], ["人流", "89"], ["竞品", "82"], ["消费力", "91"]].map(([d, s]) => (
                  <span key={d} className="text-xs bg-[#0a1a3a]/90 border border-white/20 text-white/80 px-2 py-0.5 rounded-full">{d} <span className="text-cyan-300 font-semibold">{s}</span></span>
                ))}
              </div>
            </div>
            {/* Bottom indicators */}
            <div className="grid grid-cols-4 gap-0 border-t border-white/10">
              {[["日均人流", "2.3万", "text-white"], ["竞品数量", "14家", "text-amber-300"], ["业态契合", "91%", "text-cyan-300"], ["选址建议", "强烈推荐", "text-cyan-300"]].map(([label, val, color]) => (
                <div key={label} className="px-3 py-3 text-center border-r border-white/10 last:border-0">
                  <div className={`text-sm font-bold ${color}`}>{val}</div>
                  <div className="text-white/40 text-xs mt-0.5">{label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}